'use client'

import React from 'react'
import { cn } from '@/lib/utils'
import { ChromaText } from '@/components/ui/chroma-text'

export default function IntegrationEcosystem() {
  return (
    <section className="pt-16 sm:pt-20 md:pt-28">
      <div className="container mx-auto">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-start lg:justify-between lg:gap-12">
          {/* Left: heading + description */}
          <div className="lg:max-w-2xl">
            {/* h2, not h1: this section is embedded inside pages that already
                have their own h1, and a second h1 competes with the page topic. */}
            <h2
              id="ecosys-heading"
              className={cn(
                'font-heading font-normal leading-tight m-0',
                // Responsive heading scale
                'text-2xl sm:text-3xl md:text-4xl lg:text-5xl',
                'text-foreground'
              )}
            >
              <ChromaText>Seamless Migration Capabilities</ChromaText>
            </h2>
            <p
              className={cn(
                'mt-3 sm:mt-4',
                'text-sm sm:text-base md:text-[18px]',
                'leading-relaxed',
                'text-[#6B7280]'
              )}
            >
              Our products are fully compatible with all existing systems and
              handles seamless data migration with expert precision.
            </p>
          </div>

          {/* Right: CTA link*/}
          <div className="lg:shrink-0 lg:pt-1">
            <a
              href="/migration-service"
              className={cn(
                'inline-flex items-center gap-2',
                'text-sm sm:text-base md:text-lg lg:text-xl',
                'font-medium',
                // Only prevent wrapping on lg+ where we have enough space
                'lg:whitespace-nowrap',
                'group transition-colors',
                'focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2',
                'text-foreground focus-visible:outline-[#313137]'
              )}
              aria-label="Learn about integrations"
            >
              <span className="relative inline-flex items-center gap-2">
                <span className="relative">
                  Learn about integrations
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-emerald-600 dark:bg-primary-active transition-all duration-300 group-hover:w-full" />
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden
                  className="h-4 w-4 sm:h-5 sm:w-5 transition-transform duration-300 group-hover:translate-x-1 text-foreground"
                >
                  <path
                    d="M6 4l8 8-8 8"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
